import React, { useContext, useEffect, useState } from 'react'
import styles from "./CustomerSummary.module.css"
import { useNavigate } from 'react-router-dom';
import TableManager from 'common-ui-components/components/table-manager';
import { setCustomerIdInCookies } from 'common-ui-components/accounts/framework/AuthTokenHandler';
import close from "./../icons/close.svg";
import ManualDeployment from 'app/enrollment-new/devices/deployment/ManualDeployment';
import {moduleMappingForCustomerSummary } from './CustomerSummaryColumns';
import { redirectToPage } from 'app/common/redirects/Redirects';
import { getCurrentlyRederedModule, UserDetailsContext } from 'App';
import { ALL_CUSTOMER_ID } from 'utils/mspConstants';

const map = {
    HOME_CUSTOMER_SUMMARY : "/app/home",
    INVENTORY_CUSTOMER_SUMMARY : "/app/inventory/overview",
    PATCH_CUSTOMER_SUMMARY : "/app/secure/patch-view/missing-patches",
}

const CustomerSummary = ({module=null,redirect=null}) => {
    const navigate = useNavigate();
    const [open,setOpen]=useState(false);
    const userDetails = useContext(UserDetailsContext);
    const currentCustomerId = userDetails?.currentCustomerId;

    useEffect(() => {
        if(currentCustomerId && Number(currentCustomerId) === ALL_CUSTOMER_ID) return;
        const activeModule = getCurrentlyRederedModule();
        if(activeModule in map) {
            navigate(map[activeModule])
        }
    }, [currentCustomerId])

    const handleAddCustomer=()=>{
        redirectToPage(navigate,"/app/settings/organization/customers/new-customer")
    }

    const CustomerNameLink = ({ record}) => {
        const handleLinkClick=()=>{
            if(Number(currentCustomerId)===ALL_CUSTOMER_ID)
                localStorage.setItem("forcedCustomerId",String(record.customerId));
            setTimeout(()=>redirect(),100);
        }
        return (<div 
                className={styles.link} 
                onClick={()=>handleLinkClick()}
            >
                {record.customerName}
            </div>
        );
    };

    const AgentDownload = ({ record}) => {
        const handleAgentClick=()=>{
            setCustomerIdInCookies(String(record.customerId));
            setOpen(true);
        }
        return (<div 
                className={styles.link} 
                onClick={()=>handleAgentClick()}
            >
                Download Agent
            </div>
        );
    };

    if(!module || !redirect)
        return null;

    const columns = [
        {
            title: 'Customer',
            accessor: 'customerName',
            WrapperComponent: CustomerNameLink,
        },
        ...moduleMappingForCustomerSummary[module],
        {
            title: 'Download Agent',
            accessor: 'status',
            WrapperComponent: AgentDownload,
            unsearchable: true,
            unsortable: true,
        }
    ];

    return (
        <>
            <div className={styles.header}>
                <div className={styles.title}>All Customers Summary</div>
                <div className={styles.description}>
                    Overview of each customer's current status, including total computers, outstanding patches, deployed software, and other related information.
                </div>
            </div>
            <div
                style={{
                flex: 1,
                    minHeight: 0,
                }}
            >
                <TableManager
                    headingText={'Total Customers: '}
                    columns={columns}
                    url={`/customer/getOrgCustomers?getAssociations=true${
                        Number(currentCustomerId) !== ALL_CUSTOMER_ID
                            ? `&customerId=${currentCustomerId}`
                            : ""
                    }`}
                    containerProps={{
                        style: {
                        margin: "0rem",
                        height: "calc(100vh - 150px)",
                        border: 'none',
                        },
                    }}
                    actionsConfig={[
                    {
                        label: "Add Customer",
                        props: {
                        onClick: handleAddCustomer,
                        },
                        variant: "primary",
                    },
                    ]}
                    exportNeeded={false}
                />
            </div>
            {open && (
                <div>
                    <div className={styles.box} style={{padding:"1rem"}}>
                        <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end"}}>
                            <img src={close} width={15} height={15} style={{cursor:"pointer",marginBottom:"2px"}} onClick={()=>setOpen(false)}/>
                        </div>
                        <ManualDeployment asModalChild />
                    </div>
                    <div className={styles.backdrop} onClick={() => setOpen(false)}></div>
                </div>
            )}
        </>
    )
}

export default CustomerSummary
